import Vue from 'vue';
import VCalendar from 'v-calendar';

import App from './App.vue';
import router from './router';
import i18n from './translations';
import scriptLoader from './plugins/scriptLoader';
import './utils/StringExtensions';

Vue.config.productionTip = false;

i18n.locale = 'es';

Vue.use(scriptLoader);
Vue.use(VCalendar, {
  componentPrefix: 'vc',
  locale: 'es-MX',
});

window.scrollTo(0, 0);
const VueInstance = new Vue({
  router,
  render: h => h(App),
  i18n,
});

// External scripts
const googlePromise = Vue.loadScript(
  `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_MAPS_API_TOKEN}&libraries=visualization`
);

const chartPromise = Vue.loadScript('https://www.gstatic.com/charts/loader.js');

Promise.all([chartPromise, googlePromise]).then(() => {
  VueInstance.$mount('#app');
});
